import { render, staticRenderFns } from "./AppWizard.vue?vue&type=template&id=65cee5d3&scoped=true"
import script from "./AppWizard.vue?vue&type=script&lang=js"
export * from "./AppWizard.vue?vue&type=script&lang=js"
import style0 from "./AppWizard.vue?vue&type=style&index=0&id=65cee5d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cee5d3",
  null
  
)

export default component.exports